<template>
  <div
    :class="[
      'pbs-header-container',
      active ? 'active' : null,
    ]"
  >
    <button
      v-if="finishedSection.includes(section) && !active"
      type="button"
      class="pbs-done-button"
      @click="changeActiveStepIdx(index)"
    >
      Edit
    </button>
    <button
      v-else-if="!active && incomplete"
      type="button"
      class="pbs-button"
      @click="changeActiveStepIdx(index)"
    >
      Continue
    </button>
    <button
      v-else-if="!active"
      type="button"
      class="pbs-button"
      @click="changeActiveStepIdx(index)"
    >
      Start
    </button>
    <button
      v-else
      type="button"
      class="pbs-close-button"
      @click="changeActiveStepIdx(-1)"
    >
      <img src="@shared/assets/img/setting/chevron-up.svg" alt="Up">
    </button>
    <div class="pbs-header">
      {{ header }}
    </div>
    <div class="pbs-header-right-container">
      <div
        v-if="finishedSection.includes(section)"
        class="pbs-check-container"
      >
        <img src="@shared/assets/img/general/check-white.png" alt="Checkmark">
      </div>
      <button
        v-else-if="active && toggleInfoModal"
        type="button"
        class="pbs-info-button"
        @click="toggleInfoModal"
      >
        <img
          src="@shared/assets/img/general/i-white-circle.svg"
          alt="Info"
        >
      </button>
      <div
        v-else-if="!active && incomplete"
        class="pbs-warn-container"
      >
        <img src="@shared/assets/img/promo/warning.svg" alt="Warning">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuilderHeader',
  props: {
    active: Boolean,
    finishedSection: Array,
    index: Number,
    incomplete: Boolean,
    header: String,
    section: String,
    changeActiveStepIdx: Function,
    toggleInfoModal: Function,
  },
};
</script>
